import { defineChannelContract } from 'shared/channels';
import type { Finances } from 'shared/types/analytics';
import type { ChartRequest, ChartResult } from './chartModel';

/** Contract of the page and the service worker for charts and financial data (requests the worker answers). */
export const analyticsContract = defineChannelContract<{
  requests: {
    /** The cached chart when it still matches, otherwise calculated from local data. */
    getChart: { request: ChartRequest; response: ChartResult };
    /** Costs and fines per company, calculated from the active issues. */
    getFinancialData: { request: undefined; response: Finances };
  };
  events: Record<never, never>;
}>('analyticsChannel');
